import { createUseStyles } from 'react-jss'

const useApplyChangesButtonStyles = createUseStyles({
  buttonItem: {
    display: 'flex',
    textAlign: 'center',
    padding: 20,
    height: 80,
    color: '#fff',
    textDecoration: 'none',
    backgroundColor: '#ff1c24',

    '&:hover': {
      cursor: 'pointer'
    },

    '&.disabled': {
      opacity: 0.4,
      pointerEvents: 'none'
    }
  }
})

const useRestartTileStyles = createUseStyles({
  restartTileWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 600,
    padding: '2rem',
    margin: '2rem 0',
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: '0 0 10px rgba(0,0,0,0.08)'
  },
  restartTileRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 0',
    '& > button': {
      width: 200,
      marginRight: '1rem'
    }
  }
})

export { useApplyChangesButtonStyles, useRestartTileStyles }
